module.exports = __webpack_public_path__ + "media/img/careers/why-work/why-work-img1-131dcf5beb25c0a77de4b11e077b13a5.svg";